const REWARDS = [10, 12, 15, 20]

export function getRewardPerPerson(id) {
  return REWARDS[id - 1]
}
